<template>
  <v-card class="card-limits-review-modal t-card-limits-review">
    <v-card-title class="card-limits-review-modal__heading">Please, check all information again and confirm</v-card-title>

    <scrollable-container>
      <data-row>
        <v-flex>
          <one-data-column>
            <data-label slot="label">Withdrawals</data-label>
            <div class="t-withdrawals">{{ data.withdrawals ? 'Enabled' : 'Disabled' }}</div>
          </one-data-column>

          <one-data-column>
            <data-label slot="label">Contactless payments</data-label>
            <div class="t-contactless">{{ data.contactless ? 'Enabled' : 'Disabled' }}</div>
          </one-data-column>

          <one-data-column :label-props="{ style: 'display: none;' }">
            <data-divider />
          </one-data-column>

          <one-data-column>
            <data-label
              slot="label"
              highlight
            >Purchase limits</data-label>
          </one-data-column>

          <one-data-column>
            <data-label slot="label">Daily</data-label>
            <div class="t-purchase-daily-amount">{{ data.purchaseLimit.dailyAmount | currency(currency) }}</div>
          </one-data-column>

          <one-data-column>
            <data-label slot="label">Monthly</data-label>
            <div class="t-purchase-monthly-amount">{{ data.purchaseLimit.monthlyAmount | currency(currency) }}</div>
          </one-data-column>

          <one-data-column :label-props="{ style: 'display: none;' }">
            <data-divider />
          </one-data-column>

          <one-data-column>
            <data-label
              slot="label"
              highlight
            >Cash withdrawal limits</data-label>
          </one-data-column>

          <one-data-column>
            <data-label slot="label">Daily</data-label>
            <div class="t-withdrawal-daily-amount">{{ data.withdrawalLimit.dailyAmount | currency(currency) }}</div>
          </one-data-column>

          <one-data-column>
            <data-label slot="label">Monthly</data-label>
            <div class="t-withdrawal-monthly-amount">{{ data.withdrawalLimit.monthlyAmount | currency(currency) }}</div>
          </one-data-column>
        </v-flex>
      </data-row>
    </scrollable-container>

    <v-divider class="grey lighten-3" />
    <v-card-actions class="card-limits-review-modal__actions">
      <v-btn
        class="t-confirm-button"
        color="primary"
        flat="flat"
        :disabled="isLoading"
        @click="onConfirmButtonClick"
      >
        <v-progress-circular
          v-if="isLoading"
          color="primary"
          size="22"
          width="3"
          class="mr-2"
          indeterminate
        />
        <span>confirm</span>
      </v-btn>

      <v-btn
        class="t-cancel-button"
        color="primary"
        flat="flat"
        :disabled="isLoading"
        @click="onCancelButtonClick"
      >cancel</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import IssuingApi from '@/services/Api/IssuingApi'

  // Events
  import { EVENT_CARD_LIMITS_UPDATE_SUCCESS, EVENT_CARD_LIMITS_UPDATE_ERROR } from '@/events/cardLimits'

  // Models
  import CardLimits from '@/models/CardLimits'

  // Mixins
  import modal from '@/mixins/modal'
  import flashMessages from '@/mixins/flashMessages'

  // Components
  import ScrollableContainer from '@/components/ui/ScrollableContainer'
  import DataRow from '@/components/ui/Data/DataRow'
  import OneDataColumn from '@/components/ui/Data/OneDataColumn'
  import DataLabel from '@/components/ui/Data/DataLabel'
  import DataDivider from '@/components/ui/Data/DataDivider'

  export default {
    name: 'CardLimitsReviewModal',
    components: {
      ScrollableContainer,
      DataRow,
      OneDataColumn,
      DataLabel,
      DataDivider
    },
    mixins: [modal, flashMessages],
    data () {
      return {
        updateCardLimitsApiRequest: new ApiRequest(IssuingApi.updateCardLimits, CardLimits)
      }
    },
    computed: {
      isLoading () {
        return this.updateCardLimitsApiRequest.loading
      },
      cardId () {
        return this.modalData.cardId
      },
      currency () {
        return this.modalData.currency
      },
      data () {
        console.log('this.modalData.data', this.modalData.data)
        return this.modalData.data
      }
    },
    methods: {
      onConfirmButtonClick () {
        this.updateCardLimitsApiRequest.execute(this.cardId, this.data)
          .then((cardLimits) => {
            this.closeModal()

            this.$eventHub.$emit(EVENT_CARD_LIMITS_UPDATE_SUCCESS, cardLimits)
            this.showSuccessFlashMessage('Card limits has been updated.')
          })
          .catch((error) => {
            const systemError = error.findFirstSystemError()

            this.$eventHub.$emit(EVENT_CARD_LIMITS_UPDATE_ERROR, error)
            this.showErrorFlashMessage(systemError != null ? systemError.message : 'Card limits has not been updated.')
          })
      },
      onCancelButtonClick () {
        this.closeModal()
      }
    }
  }
</script>

<style lang="scss">
  .card-limits-review-modal {
    font-size: 16px;
    font-weight: 400;

    &__heading,
    .container {
      padding-right: 30px;
      padding-left: 30px;
    }

    &__heading {
      font-size: 24px;
      font-weight: 400;
      line-height: 32px;
      padding-top: 21px;
    }

    &__actions {
      padding: 14px 14px;
    }
  }
</style>
